'use client';

import "../../debounce-DY4Q9peb.js";
import { createAdapterProvider } from "../../context-BxT884es.js";
import "../../reset-DAVNyB3X.js";
import { useNuqsNextPagesRouterAdapter } from "../../impl.pages-BzxohkJJ.js";

//#region src/adapters/next/pages.ts
const NuqsAdapter = createAdapterProvider(useNuqsNextPagesRouterAdapter);

//#endregion
export { NuqsAdapter };
//# sourceMappingURL=pages.js.map